import React, { useCallback, useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { getPractitionersAdmin } from 'api/Practitioner';
import { iaRa } from 'lib/helpers/utility';
import { useInfiniteFetchData } from 'lib/hooks/useInfiniteFetchData';
import Input from 'components/shared/Input/Input';
import UserList from './UserList';

const AllUsersList = ({ isOpen, selectedUser, setSelectedUser, onTotalCount }) => {
  const scrollRef = useRef(null);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  const {
    data: allUsers,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteFetchData({
    queryKey: 'practitioner',
    queryFn: getPractitionersAdmin,
    params: { searchTerm: debouncedSearch, page: 1, limit: 25, withCount: true },
    dependencies: [debouncedSearch],
    options: { enabled: isOpen },
    onSuccess: (d) => {
      const c = parseInt(d?.pages?.[0]?.count, 10);
      if (!isNaN(c)) onTotalCount?.(c);
    }
  });

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (
      el &&
      el.scrollTop + el.clientHeight >= el.scrollHeight - 1 &&
      hasNextPage &&
      !isFetchingNextPage
    )
      fetchNextPage();
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  useEffect(() => {
    const handler = debounce(() => setDebouncedSearch(search), 500);
    handler();
    return () => handler.cancel();
  }, [search]);

  useEffect(() => {
    if (!isOpen) setSearch('');
  }, [isOpen]);

  return (
    <>
      <div className="px-4 pt-3">
        <Input
          icon="search-linear"
          placeholder="Search users"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          inputWrapperClassName="!bg-transparent !h-10"
        />
      </div>
      <UserList
        users={iaRa(allUsers)}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        scrollRef={scrollRef}
        onScroll={handleScroll}
        isFetchingNextPage={isFetchingNextPage}
      />
    </>
  );
};

export default AllUsersList;
